import AccordionSummary from '@material-ui/core/AccordionSummary';

export default AccordionSummary;
